export * from './urlPathAndQueryParams';
export * from './routeConstants';

export const DAY = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];

export const MONTH = ['JANUARY', 'FEBRUARY', 'MARCH',
    'APRIL', 'MAY', 'JUNE', 'JULY',
    'AUGUST', 'SEPTEMBER', 'OCTOBER',
    'NOVEMBER', 'DECEMBER'];

// returns available breakpoints
export const BREAKPOINTS = {
    XS: 768,
    SM: 992,
    MD: 1200,
    LG: 1600,
    XL: 1920
};
// returns cards per page based on view port
export const DASHBOARD_CARD_PER_PAGE_COUNT = {
    XS: 14,
    SM: 2,
    MD: 2,
    LG: 3,
    XL: 4
};
// returns available carousel pages based on view port
export const DASHBOARD_MAX_CAROUSEL_PAGES = {
    XS: 1,
    SM: 7,
    MD: 7,
    LG: 7,
    XL: 7
};


export const isDataUnityVisible = true;

export const REJECTION_REASON = ['Logistical/timing requirement (please provide details in remarks)', 'Finance transactional requirement (please provide details in remarks)',
    'Process requirement (please provide details in remarks)',
    'Internal (Honeywell) Purchases'];

export const FEEDBACK_REASON = ['The anomalies assigned to me are incorrect.', 'Too many anomalies are assigned to me.', 'No anomalies visible in my dashboard.', 'I am getting frequent emails.', 'Anything else? Please type below.'];
export const AUDIT_REJECT_REASON = ['Comments are not clear', 'Disagree with anomaly dispositioning', 'Other'];

export const ERROR_MSG_FOR_USER_RESPONSE = 'Something went wrong, please try again!';

export const DATAGPT_NO_DATA_FOUND = 'No data fetched. Try again later!';

export const FILE_UPLOAD_FORMAT_ERROR = 'File Size of 20MB with following extension is supported .jpeg, .pdf, .jpg, .docx, .xlsx, .png plese retry with valid file';

export const FILE_UPLOAD_MANDATORY = "Note: Uploading file is mandatory";

export const FILE_UPLOAD_MANDATORY_COMMENT = "Note: Uploading file is mandatory to save the changed comment and complete the task.";

export const SAMPLING_ANAMOLIES_TEXT = 'Please complete your sample anomalies list review within 14 days.It is recommended not to make another list until the current one has been reviewed.'

export const SAMPLING_ANAMOLIES_TEXT_DOMAIN_FOCAL = 'Please complete your sample anomalies list review within 90 days.It is recommended not to make another list until the current one has been reviewed.'

export const ORPHAN_ANAMOLIES_TEXT = 'Please review your unassigned anomalies list and create a group in RBAC.'

export const SAMPLING_ANAMOLIES_NO_REVIEW_TEXT = 'In the last three months,no new anamolies have been reviewed in the application. No anmolies have been added to the sample bucket.';


export const LOCAL_STORAGE_CONSTANTS = {
    PSR_TEST_ID: 'psr_test_id'
};
export const SESSION_STORAGE_CONSTANTS = {
    URL_PARAMS: 'url_params'
};
/** enum representing indexes of dashboard tab  */
export enum DASHBOARD_TABS {
    //DASHBOARD = 0,
    OVERVIEW = 0,
    ALL_OPPORTUNITIES = 1,
    SAMPlEPAGE = 2
}

export type OPPORTUNITY_STATUS_TYPE = 'open' | 'accepted' | 'rejected' | 'realized';

export const ROLE_NAME = {
    EDITOR: 'insight.editor',
    OWNER: 'insight.owner',
    VIEWER: 'insight.viewer'
};

export const USER_ROLE = {
    REVIEWER: 'insight.owner',
    VIEWER: 'insight.viewer',
    ORG_USER: 'insight.org_user',
    DOMAIN_FOCAL:'insight.domain_focal',
    POWER_USER: 'insight.power_user',
    LEADERSHIP_USER: 'insight.functional_leadership',
    ADMIN_USER: 'insight.admin_user',
    MODEL_POWER_USER:'model.power_user',
    MODEL_LABELER:'model.labeler',
    MODEL_FUNCTIONAL_LEADERSHIP:'model.functional_leadership'

};
/** Status of an action(API call, submit button click - user interactions, etc) */
export type ACTION_STATUS = 'idle' | 'loading' | 'finished' | 'error';

export const REJECT_TOAST_MSG = 'Thank you for your feedback, this will help us make better recommendations for you next time.';

export const PO_NUMBERS_COPIED = 'Transaction numbers copied';

export const getRealizationToastMsg = (currentPercentage: number, kpiName: string) => `Congratulations, you have achieved ${currentPercentage}% of your ${kpiName} goal! You are doing great, thank you for all your hard work.`;

export const DEFAULT_REALIZATION_TOAST_MSG = 'Congratulations!! You are doing great, thank you for all your hard work.';

export const EMPTY_NOTES_TEXT = 'Capture comments as you progress.';

export const ON_BOARDING_HEADER = ['', 'Subscribe to categories', 'Enter your AOP Targets'];

export const ON_BOARDING_DESC = ['Welcome to Honeywell Forge Insights where predictive and prescriptive insights meet actionable opportunities.',
    'Receive insights by selecting the categories that will help you be most successful in achieving your goals.',
    'As you accept opportunities Forge Insights will compare their potential and realized value to your AOP targets.'
];

/** enum representing for all opportunity page filter column name  */
export const FILTER_COLUMN_NAME = {
    STATUS: 'insight_status',
    SEARCH: 'search'
};
/** enum representing for all opportunity page filter label to display pills  */
export const FILTER_LABEL_NAME = {
    STATUS: 'Status',
    SEARCH: '',
    SORT: '',
    EXPORT:'Export'
};
/** enum representing for all opportunity page filters group name */
export const FILTER_GROUP_NAMES = {
    STATUS: 'STATUS',
    SEARCH: 'SEARCH',
    SORT: 'SORT',
    EXPORT:'EXPORT'
};

/** opportunity Modal */
export const OPP_MODAL_BUTTONS = {
    ACCEPT: 'Action Required',
    REJECT: 'No Action Required',
    COMMENT: 'Comment',
    CONTEXT: 'Get More Context',
    REQUEST_INPUT: 'Share',
    CLAIM_OWNERSHIP: 'Claim Ownership',
    AUDIT_REJECT: 'Audit Reject',
    AUDIT_ACCEPT: 'Audit Accept',
    BUSINESS_REJECT: 'Business Reject',
    BUSINESS_ACCEPT: 'Business Accept',
    REVIEW_TASK: 'Review Task',
    REVIEW:'Review'
};
export const USER_RESPONSE_STATUS = {
    ACCEPT: 'accept',
    REJECT: 'reject',
    ACCEPT_ORG_USER: 'accept-org-user',
    REJECT_ORG_USER: 'reject-org-user'
};
export const AUDIT_RESPONSE_STATUS = {
    REJECT: 'audit-reject',
    ACCEPT: 'audit-accept',
    BUSINESS_REJECT: 'business-reject',
    BUSINESS_ACCEPT: 'business-accept',

};

export const INPUT_COLOR_DISABLED = '#f7f7f';

export const OPPORTUNITY_STATUS = {
    OPEN: 'open',
    ACCEPTED: 'accepted',
    REJECTED: 'rejected',
    ACCEPTED_ORGUSER: 'accepted-org-user',
    REJECTED_ORGUSER: 'rejected-org-user'
};
// Status Labels
export const OPEN_STATUS_TEXT = 'open';

export const ACCEPT_STATUS_TEXT = 'accepted';

export const ACCEPT_ORG_USER_STATUS_TEXT = 'accepted-org-user';

export const REJECT_STATUS_TEXT = 'rejected';

export const REJECT_ORG_USER_STATUS_TEXT = 'rejected-org-user';

export const ALL_STATUS_TEXT = 'all';

// Status Texts
export const OPEN_STATUS_LABEL = 'Open';

export const ACCEPT_STATUS_LABEL = 'Action Required';

export const REJECT_STATUS_LABEL = 'No Action Required';

export const ACCEPT_ORG_USER_STATUS_LABEL = 'Completed-Action Required';

export const REJECT_ORG_USER_STATUS_LABEL = 'Completed-No Action Required';

export const ALL_STATUS_LABEL = 'All';

export const REJECT_POPUP_TITLE = 'No Action Required? What was the business reason to split the transactions?';

export const ACCEPT_POPUP_TITLE = 'What should be the corrective action?';

export const MORE_CONTEXT_POPUP_TITLE = 'Get More Context';

export const REQUEST_INPUT_TITLE = 'Share';

export const REVIEWER_ACCEPT_STATUS_LABEL = 'Reviewer-Action taken';

export const REVIEWER_REJECT_STATUS_LABEL = 'Reviewer-No Action taken:';

export const ORG_USER_ACCEPT_STATUS_LABEL = 'Org Owner-Action taken';

export const ORG_USER_REJECT_STATUS_LABEL = 'Org Owner-No Action taken';

export const GET_CONTEXT_LEGAL_TEXT_DECLARATION = "The employee from whom I intend to request more context is not located in Austria, Belgium, France, Germany, Italy, or the Netherlands."

export const GET_CONTEXT_LEGAL_TEXT_NOTICE = "CAMS is not yet approved for use in Austria, Belgium, France, Germany, Italy, or the Netherlands. Requests for more context may only be sent to employees outside of these countries."

export const RESET_FILTER_OPTION_TEXT = "Select an option";

export const ACTION_ALREADY_COMPLETED_TEXT = "Action owner has already completed the action, and evidence is attached to the anomaly.";

export const ACTION_ALREADY_COMPLETED_NOTE = "Note: Use the window below to attach the evidence and close the action.";

export const ACTION_ALREADY_COMPLETED_UPLOAD_TEXT = "Please attach evidence of completion before you can close the action (screenshot, email etc.).";

export const MAIL_SENT = 'Mail Sent';

export const REJECT_SUBTITLE = 'No Action Required? Please provide remarks.'

export const REJECT_NOTES = "Note: Anomalies dispositioned without any support for your reasoning are more likely to be rejected by your business focals or the Audit team. If you haven’t done so already, please consider whether there is any support for your dispositioning decision that can be attached."

export const COMMENT_TYPE = {
    COMMENT: 'commented ',
    CLAIM_OWNWERSHIP: 'claimed ownership for this anomaly.',
    ACTION: 'marked this anomaly as action required.',
    MORE_CONTEXT: 'shared this anomaly with',
    UPLOAD: 'uploaded file',
    AUDIT: 'this anomaly',
    TRACKINGSUBMIT: 'has completed assigned action',
    TRACKINGCOMPLETE: 'has completed the review',
    TRACKINGOPEN: 'has requested action with',
    TRACKINGREMINDER: 'has sent reminder to'
};

export const COMMENT_ACTION = {
    ACCEPT: ' marked this anomaly as action required.',
    REJECT: 'marked this anomaly as no action required.',
    REOPEN: 'reopen this anomaly.'
};

export const REVIEWER_STATUS = {
    OPEN: 'Pending for hand-off to Org owner',
    ACTION_TAKEN: 'Pending with Org owner',
    NO_ACTION_TAKEN: 'Reviewed, no action required',
    ASSIGNED_TO_ORG_USER: 'Org owner review completed',
    POWER_USER_REJECTED: 'Audit Rejected by Power User'
};

export const ACTION_TRACKING_STATUS = {
    INCOMPLETE: 'incomplete',
    PARTIALLY_COMPLETE: 'partially_complete',
    ALL_COMPLETE: 'all_complete',
    ORG_USER_COMPLETE: 'org_user_complete'
};

export const PROPOSED_ACTION_TRACKING_DISPLAY_CATEGORIES = ['G&H Trends', 'UI 5'];

/** Reviewer-proposed action_tracking row statuses */
export const PROPOSED_ACTION_TRACKING_STATUS = {
    PROPOSED: 'proposed',
    PROPOSED_COMPLETED: 'proposedcompleted'
};


export const COMMENT_NOTE = 'Note: The comment entered is visible to all users.';

export const IMAGE_NOT_FOUND = "Image not found";

export const ALERT = 'Alert';

export const AUDIT_REJECT_NOTE = 'Note: The action can not be undone after clicking on the submit button';

export const REQUIRED = 'This field is required';
export const HAS_SCRIPT = 'Following characters are not allowed: <> () & #';
export const ACKNOWLEDGE_SUCCESS = 'Acknowledged';
export const PROJECT_DOMAIN = 'Project';
export const UNREVIEWED = 'Unreviewed';
export const  AUDIT_REJECTED_UNREVIEWED ='Audit Rejected - Unreviewed';
export const  BUSINESS_REJECTED_UNREVIEWED ='Business Rejected - Unreviewed';

export const REVIEWED_ACTION_COMPLETE = 'Reviewed - Action Complete';
export const REVIEWED_ESCALATED = 'Reviewed - Escalated';
export const FILE_UPLOAD_WARNING = 'Please upload the file before submiting';

export const COMPLETE_WARNING = 'By clicking on the below “Complete” button you are giving your agreement that you have completed all tasks and all proofs have been attached. You cannot undo or go back after hitting complete so please be sure that all of your tasks are fully completed and all of your respective proofs are attached before moving on to complete.'
export const REVIEW_WARNING = 'Please review the attachments carefully and click on the complete button once finished.'
export const COMPLETE_TITLE = 'Attention: Read before you proceed';

export const COMMENT_UPLOAD_TYPE = 'comment-upload';
export const TRACKING_UPLOAD_TYPE = 'tracking-upload';
export const TRACKING_SUBMIT = 'tracking-submit';
export const TRACKING_REMINDER = 'tracking-reminder';
export const TRACKING_COMPLETE = 'tracking-complete';


export const ACTION_UPLOAD_TYPE = 'action-upload';

export const CHECKLIST_UPLOAD_TYPE = 'checklist-upload';

export const UNAVAILABLE_HOSTNAME = 'cam-dashboard-gbpjqpyj-qa.apps.dev.aro.forgeapp.honeywell.com';

export const DELETERECORD_MESSAGE = 'Please uncheck the checkbox to delete this record';

export const STATUS_MAPPING_DISPLAY: any = {
    'insight.owner': {
        'uimap': {
            'open': 'unreviewed',
            'accepted': 'reviewed',
            'rejected': 'reviewed',
            'all': 'all'
        },
        'apimap': {
            'unreviewed': 'open',
            'reviewed': 'accepted,rejected',
            'all': 'all'
        }
    },
    'insight.org_user': {
        'uimap': {
            'accepted-org-user': 'reviewed',
            'rejected-org-user': 'reviewed',
            'accepted': 'awaiting review',
            'rejected': 'no review required',
            'all': 'all'
        },
        'apimap': {
            'reviewed': 'accepted-org-user,rejected-org-user',
            'awaiting review': 'accepted',
            'no review required': 'rejected',
            'all': 'all'
        }
    },
    'insight.viewer': {
        'uimap': {
            'open': 'unreviewed',
            'accepted': 'reviewed',
            'rejected': 'reviewed',
            'all': 'all'
        },
        'apimap': {
            'unreviewed': 'open',
            'reviewed': 'accepted,rejected',
            'all': 'all'
        }
    },
    'insight.power_user': {
        'uimap': {
            'open': 'unreviewed',
            'accepted': 'awaiting review',
            'rejected': 'no review required',
            'accepted-org-user': 'reviewed',
            'rejected-org-user': 'reviewed',
            'all': 'all'
        },
        'apimap': {
            'unreviewed': 'open',
            'awaiting review': 'accepted',
            'no review required': 'rejected',
            'reviewed': 'accepted-org-user,rejected-org-user',
            'all': 'all'
        }
    },
    'insight.functional_leadership': {
        'uimap': {
            'open': 'unreviewed',
            'accepted': 'awaiting review',
            'rejected': 'no review required',
            'accepted-org-user': 'reviewed',
            'rejected-org-user': 'reviewed',
            'all': 'all'
        },
        'apimap': {
            'unreviewed': 'open',
            'awaiting review': 'accepted',
            'no review required': 'rejected',
            'reviewed': 'accepted-org-user,rejected-org-user',
            'all': 'all'
        }
    }

};



//Overview constants

export const OVERVIEW_LOOKUP_NAMES = {
    ORGANIZATION: 'org_name',
    ALERT: 'alert',
    DOMAIN: 'domain',
    STATUS: 'insight_display_status',
    AUDIT_STATUS:'audit_display_status',
    BUSINESS_STATUS:'business_display_status',
    GBE:'gbe',
    REGION: 'region',
    DOLLAR_VALUE: 'dollar_value',
    CREATED_ON: 'created_on',
    RISK_RATING: 'risk_level',
    COUNTRY: 'country_code',
    RISK: 'Risk',
    FILTER_TYPE : 'in'
};

export const NO_RECORDS_FOUND = "No Records Found";

export const DATE_FILTER_RANGE =  {
    THREE_MONTHS: 90,
    SIX_MONTHS: 182, 
    ONE_YEAR: 365,
    THREE_YEARS: 1095,
    ALL_TIME_START: "2021-10-01",
}
export const OVERVIEW_LOOKUP_CATEGORY = {
    TRENDS: 'trends',
    ALL: 'all',
    ALL_CATEGORIES: "All Categories",
    ORG_OWNER: "Org Owner",
    REVIWER: "Reviewer"
}

export const OVERVIEW_RISK_RATING_CATEGORY ={
    HIGH: "High",
    LOW:"Low",
    MEDIUM:"Medium",
    VIEW_RISK:"View Risk",
    ALL :"All"
}


export const OVERVIEW_DOMAIN_CATEGORY = {
    PROCUREMENT: 'Procurement',
    PRICING: 'Pricing',
    SALES: 'Sales',
    FINANCE: 'Finance',
    PROJECT:'Project',
    COMPLIANCE:'Compliance',
    ALL: 'All',
    ALLDOMAIN:'All Domain',
    RESET_TEXT: 'Select an option',
    SELECT_VALUE:'Select value'
};

export const ORGANIZATION_SBGGBE_CATEGORY ={

    RESET_TEXT: 'Select an option',

}

export const OVERVIEW_VIEW_TYPE = {
    ALL_ANAMOLIES: 'all_anomalies',
    OVERDUE_ANOMALIES_VIEW: 'overdue_anomalies',
    ACTION_ASSIGNMENT_VIEW: 'action_assignment',
    TREND_USER_ACTIVITY_VIEW: 'trend_user_activity',
    TREND_OVERDUE_ANOMALIES_VIEW: 'trend_overdue_anomalies',
    TREND_ACTION_REQUIRED_VIEW: 'trend_assigned_anomalies_requiring_actions',
    TREND_IDENTIFIED_ANOMALIES_VIEW: 'trend_identified_anomalies',
    TREND_AUDIT_REJECTIONS_VIEW: 'trend_audit_reject',
    TREND_BUSINESS_REJECTIONS_VIEW: 'trend_business_reject',
    USER_ACTIVITY: 'dashboard_user_activity'
}

export const TRENDS = [
    OVERVIEW_VIEW_TYPE.TREND_USER_ACTIVITY_VIEW,
    OVERVIEW_VIEW_TYPE.TREND_OVERDUE_ANOMALIES_VIEW,
    OVERVIEW_VIEW_TYPE.TREND_ACTION_REQUIRED_VIEW,
    OVERVIEW_VIEW_TYPE.TREND_IDENTIFIED_ANOMALIES_VIEW,
    OVERVIEW_VIEW_TYPE.TREND_AUDIT_REJECTIONS_VIEW,
    OVERVIEW_VIEW_TYPE.TREND_BUSINESS_REJECTIONS_VIEW
]


export const OVERVIEW_CONSTANTS = {
    UNREVIEWED: 'unreviewed',
    REVIEWED_AWAITING_ORG_OWNER_APPROVAL: 'reviewed-awaiting_org_owner_approval',
    REVIEW_ACTION_ASSIGNED: 'reviewed-action_assigned',
    CLOSED_ON_TIME: 'closed on time',
    CLOSED_LATE: 'closed late',
    OVERDUE_SEVEN: "7",
    OVERDUE_FIFTEEN: "15",
    OVERDUE_THIRTY: "30",
    RISK_LEVEL: 'risk_level',
    ROLL_UP_STATUS: 'rollup_status',
    STATUS: 'status',
    INSIGHT_DISPLAY_STATUS:'insight_display_status',
    CLOSED_STATUS: 'closed_status',
    OVERDUE_DAYS: 'overdue_days',
    OVERDUE_STATUS: 'overdue_status',
    OPEN: 'open',
    COMPLETED: 'completed',
    PENDING: 'pending',
    HIGH: 'High',
    LOW: 'Low',
    MEDIUM: 'Medium',
    FILTER_STATUS:'filter_status',
    ROLE_NAME: 'role_name',
    USER_NAME:'user_name',
    OVERDUE : 'Overdue anomalies',
    ANOMALY : 'Anomalies',
    USER_ID: 'user_id',
    TRENDS_MONTH:'trends_month',
    TITLE:'title'
}
export const TRENDS_TYPE = {
    OPEN: "open",
    REVIEWED_ON_TIME: "reviewedontime",
    REVIEWED_LATE: "reviewedlate",
    TRENDS_DATE: "trends_date",
    PRICING: "Pricing",
    PROCUREMENT: "Procurement",
    SALES: "Sales",
    FINANCE:"Finance",
    PROJECT:"Project",
    COMPLAINCE:"Compliance",
    TOTAL_COUNT: "total_count",
    OVERALL_COUNT: "overall_count",
    MONTH: "month"
}

export const TRENDS_TEXT ={
    USER_ACTIVITY_TREND:'User Activity Trend',
    OVERDUE_ANOMALIES: 'Overdue Anomalies',
    ACTIONS_REQUIRED:'Action Required Anomalies',
    IDENTIFIED_ANOMALIES:'Identified Anomalies',
    AUDIT_REJECTIONS:'Audit Rejections',
    BUSINESS_REJECTIONS:'Business Rejections',
    HYPHEN_OVERDUE_ANOMALIES: '- Overdue Anomalies',
    HYPHEN_ACTIONS_REQUIRED:'- Assigned Anomalies Requiring Actions',
    HYPHEN_IDENTIFIED_ANOMALIES:'- Identified Anomalies',
    HYPHEN_AUDIT_REJECTIONS:'- Audit Rejections',
    HYPHEN_BUSINESS_REJECTIONS:'- Business Rejections',
    IN:'in',
    JPEG:'JPEG',
    TRENDS:'Trends',
    IMAGE_PNG:'image/png',
    SELECT_OPTION:'Select an option',
    FILE_DOWNLOAD:'file-download',
    OPEN:'Open',
    REVIEWED_ON_TIME:'Reviewed on time',
    REVIEWED_LATE:'Reviewed late',
    CLOSED:'Closed',
    NO_DATA:'No data',
    ANOMALY_COUNT:'Anomaly count',
    ANOMALY_REQUIRED_COUNT: "Total count of anomalies reviewed with action required",
    ANOMALY_PERCENTAGE: '% of anomalies requiring action',
    AUDIT_REJECTED_ANOMALY:'Audit rejected anomaly',
    BUSINESS_REJECTED_ANOMALY:'Business rejected anomaly',
    ACTION_REQ_ANOMALY:'Action req. anomalies',
    SOLD_BY:'sold by',
    ON:'on',
    ANOMALIES:'Anomalies',
    ACTION_REQUIRING:'Action Requiring',
    ACTION_REQ_ANOMALIES:'Action requiring anomalies',
    CLOSED_ACTION:'Closed actions',
    OPEN_KEY:'open',
    REVIEWED_ON_TIME_KEY:'reviewed_on_time',
    REVIEWED_LATE_KEY:'reviewed_late',

}
export const TRENDS_COLORS={
    DARK_GRAY:'#303030',
    LIGHT_PINK:"#EE4983",
    CYAN:'#0098B0',
    BLUE:'#6882FE',
    VIOLET_RED:'#D25EAA',
    BUSINESS_REJECTION_COL :"#F69791",
    LIGHT_GRAY:'#F0F0F0',
    DARK_RED:'#d50c13',
    HEAT_GRAY: '#d0d0d1',
    HEAT_LEGENDS: ['#d50c13', '#ee4982', '#f69891','#fbccc9', '#d0d0d1'],
    TRANSPARENT:'transparent'
}

export const TRENDS_MONTH =['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']

export const REVIEW_PERFORMANCE = {
    TITLE: "Review Performance",
    TRANSPARENT: "transparent",
    ORG_OWNER: 'orgUsers',
    REVIEWER: 'reviewers',
    UNREVIEWED: "Unreviewed",
    REVIEWED_LATE: "Reviewed Late",
    REVIEWED_LATE_TEXT: "Reviewed late",
    REVIEWED_ONTIME: "Reviewed On Time",
    REVIEWED_ONTIME_TEXT: "Reviewed on time",
    AWAITING_REVIEW: "Awaiting review",
    REVIEWED: "Reviewed",
    REVIEWED_ONTIME_COLOR: "#64C3FF",
    REVIEWED_LATE_COLOR: "#0a559d",
    UNREVIEWED_COLOR: "#FFC527",
}


export const AUDIT_REJECTIONS = {
    TITLE: "Audit Rejections",
    ORG_OWNER: 'orgUsers',
    REVIEWER: 'reviewers',
    REJECTED_ANOMALIES_PERCENTAGE:"rejected_anomalies_percentage" ,
    ANOMALY_REVIEWED :"anomaly_reviewed", 
    ANOMALY_REJECTED:"anomaly_rejected" ,
    UNIQUE_ANOMALY_REJECTED:"unique_anomaly_rejected" ,
    NUMBER_OF_UNIQUE_ANOMALIES_REJECTED_COLOR: "#D25EAA",    
    NUMBER_OF_ANOMALIES_REVIEWED:"Count of anomalies reviewed by user",
    NUMBER_OF_UNIQUE_ANOMALIES_REJECTED:"Count of anomalies rejected by audit",
    NUMBER_OF_REJECTIONS_FACED_BY_USER:"Count of audit rejections for this user",

}

export const CALANDER_OPTIONS =["Custom","3 Months", "6 Months", "1 Year", "3 Year","All Time"];

export const HEAT_MAP_ALERTS = ['Alert 1', 'Alert 2', 'Alert 3', 'Alert 4', 'Alert 5'];

export const FOOTER_TEXT={
    FOOTER_PERCENTAGE:"%",
    TITLE:'title',
    SUBVALUE:"subValue",
    SUBTITLE:'subTitle',
    VALUE:'Value',
    ARROW_UP:'arrow-up',
    ARROW_DOWN:'arrow-down',
    ROTATE_ANTICLOCKWISE:'rotate_arrow_counterclockwise',
    ROTATE_CLOCKWISE:'rotate_arrow_clockwise',
    GREEN:'green_color',
    RED:'red_color',
    CONTAINER_BORDER:'container-border',
}

export const OVERVIEW_CALANDER ={
    CUSTOM: "Custom",
    THREE_MONTHS:"3 Months",
    SIX_MONTHS:"6 Months", 
    ONE_YEAR: "1 Year",
    THREE_YEARS: "3 Year",
    ALL_TIME: "All Time",
    CALENDAR :'calendar'
}

export const  OVERVIEW_OBJECT_KEY={
    DAYS_15:"7-15 days",
    DAYS_30:"15-30 days",
    DAYS_MORE_THAN_30:"More than 30 days",
    CLOSED:"Closed",
    OPEN:"Open",
    UNREVIEWED:"Unreviewed",
    REVIEWD_AWAITING_ORG_OWNER_APPROVAL:"Reviewed - Awaiting Org Owner Approval",
    REVIEWED_ACTION_ASSIGNED:"Reviewed - Action Assigned",
    CLOSED_ON_TIME:"Closed on time",
    CLOSED_LATE:"Closed late",
    HIGH:"High",
    LOW:"Low",
    MEDIUM:"Medium"
}

export const  ANOMALY_TYPE_UI={
 ALL:"All",
 OPEN:"Open",
 CLOSED:"Closed",
 OVERDUE:"Overdue"
}

export const REVIEW_IMMIDIATELY_TEXT ={
   QUICK_SUMMARY: "Quick Summary",
   FETCHING_DATA: "Fetching Quick Summary ..."
}

export const ANOMALIES_LOOKUP_NAMES={
    STATUS:'status',
    INSIGHT_STATUS: 'insight_display_status',
    AUDIT_STATUS: 'audit_display_status',
    BUSINESS_STATUS: 'business_display_status',
    REVIEWER:'reviewer',
    ORGUSER:'org_user',
    COUNTRY_CODE:'country_code',
    DOMAIN:'domain',
    DOMAIN2: 'insight_module_name',
    ALERT:'alert',
    ALERT2: 'insight_summary_display_category',
    REGION: 'region',
    COUNTRY_NAME: 'country_name'
}

export const STATUS_TYPES = [ 'insight_display_status', 'audit_display_status', 'business_display_status' ]

export const COLUMN_REVERSE_MAP = {
    'insight_summary_display_category': 'alert',
    'status': 'insight_display_status'
}


export const BADGE_NAMES = {
    'domain': 'domain',
    'alert': 'alert',
    'org_name': 'Organization',
    'risk_level': 'risk',
    'insight_display_status': 'status',
    'audit_display_status': 'Audit Status',
    'business_display_status': 'Business Status',
    'region': 'region',
    'country_code': 'country',
    'country_name': 'country',
    'dollar_value': '$',
    'created_on': 'Date',
    'overdue_status': 'Overdue',
    'role_name': 'Role',
    'insight.org_user': 'Org Owner',
    'Insight.Org_user': 'Org Owner',
    'org_user': 'Org Owner',
    'closed_status': 'Status',
    'insight.owner': 'Reviewer',
    'reviewer': 'reviewer',
    'user_name': 'User',
    'rollup_status': 'Status',
    'status': 'Review Status',
    'insight_module_name': 'Domain',
    'insight_id': 'Anomaly Id',
    'Insight_summary_display_category': 'Alert',
    'insight_summary_display_category': 'Alert',
    'gbe': 'organization',
    'trends_month':'Trends Month',
    'anomaly_rejected':'Anomaly Rejected'
}

export const BADGE_CLASSNAMES = {
    'insight_module_name': 'badge-orange',
    'insight_summary_display_category': 'badge-blue',
    'insight_display_status': 'badge-yellow',
    'region': 'badge-red',
    'country_code': 'badge-purple',
    'reviewer': 'badge-green',
    'org_user': 'badge-dark-red',
    'trends_month': 'badge-pink',
    'title': 'badge-gray',

    // unknown keys
    'domain': 'badge-orange',
    'alert': 'badge-blue',
    'org_name': 'badge-yellow',
    'risk_level': 'badge-red',
    'audit_display_status': 'badge-green',
    'business_display_status': 'badge-dark-red',
    'country_name': 'badge-gray',
    'dollar_value': 'badge-pink',
    'created_on': 'badge-orange',
    'overdue_status': 'badge-blue',
    'role_name': 'badge-yellow',
    'insight.org_user': 'badge-red',
    'Insight.Org_user': 'badge-purple',
    'closed_status': 'badge-dark-red',
    'insight.owner': 'badge-dark-blue',
    'user_name': 'badge-gray',
    'rollup_status': 'badge-pink',
    'status': 'badge-orange',    
    'insight_id': 'badge-yellow',    
    'gbe': 'badge-green'
}

export const BADGE_VALUES = {
    'Insight.Owner': 'Reviewer',
    'insight.owner': 'Reviewer',
    'Insight.Org_user': 'Org User',
    'insight.org_user': 'Org User',
    'Y': 'True',
    'anomaly_rejected':'Anomaly Rejected',
    'open':'Open',
    'reviewed_on_time':'Reviewed on time',
    'reviewed_late':'Reviewed late'
}

export const EXPORT_LOOKUP_CONSTANTS={
    EXPORT_ANOMALY_DETAIL:'Export Anomaly Details',
    EXPORT_NOTE:'Please select fields from the list below. They will be exported in addition to the columns from the anomalies page.',
    PROCUREMENT:'Procurement',
    PRICING:'Pricing',
    SALES:'Sales',
    NO_DATA:'No data',
    DOMAINS:["Procurement","Sales","Pricing"],
    DOMAIN_NAME:'domain',
    LABEL_NAME:'label_name',
    LABEL_GROUP: 'label_group',
    INSIGHT_ID:'insight_id',
    DEFAULT_LABEL:"default_label"
}

export const CHART_TYPE = {
    OVERDUE: 'overview',
    TRENDS: 'trends',
    PERSONA: 'user-activity',
    ACTION_ASSIGNMENT:'action-assignment',
    DEFAULT: 'overview',
    ALERT_BASED_DISTRIBUTION:'alert',
    ALERT_HEAT:'heat',
    REVIEW_PERFORMANCE: "review-performance",
    AUDIT_REJECTIONS: "audit-rejections"

}

export const CHART_TABS = {
    [CHART_TYPE.OVERDUE]: 1,
    [CHART_TYPE.ACTION_ASSIGNMENT]:2,
    [CHART_TYPE.PERSONA]:3,
    [CHART_TYPE.ALERT_BASED_DISTRIBUTION]:4,
    [CHART_TYPE.TRENDS]: 5,
    DEFAULT:1
}

export const  SLIDER = [CHART_TYPE.OVERDUE, CHART_TYPE.ACTION_ASSIGNMENT, CHART_TYPE.PERSONA,CHART_TYPE.AUDIT_REJECTIONS,CHART_TYPE.ALERT_BASED_DISTRIBUTION, CHART_TYPE.REVIEW_PERFORMANCE, CHART_TYPE.TRENDS]

export const SLIDER_TOOLTIP = {
    [CHART_TYPE.OVERDUE]: 'Overview',
    [CHART_TYPE.ACTION_ASSIGNMENT]: 'Action Assignment',
    [CHART_TYPE.PERSONA]: 'User Activity',
    [CHART_TYPE.ALERT_BASED_DISTRIBUTION]: 'Alert Distribution',
    [CHART_TYPE.REVIEW_PERFORMANCE]: 'Review Performance',
    [CHART_TYPE.TRENDS]: 'Trends',
    [CHART_TYPE.AUDIT_REJECTIONS]: 'Audit Rejections',
  };

export const QUERY_PARAMS = {
    CHART: 'chart'
}

export const VIEW_TYPE = {
    DASHBAORD_VIEW: 'dashboard',
    ALL_ANOMALIES_VIEW: 'all_anomalies',
    OVERDUE_ANOMALIES_VIEW: 'overdue_anomalies',
    ACTION_ASSIGNMENT_VIEW: 'action_assignment',
    USER_ACTIVITY: 'dashboard_user_activity',
    ALERT:{
        BAR:'dashbord_alert_distribution',
        HEAT: 'dashbord_alert_heat_distribution'
    },
    PENDING_ACTIONS:'anomalies_pending_action_requests',
    TRENDS: TRENDS,
    TREND_USER_ACTIVITY: 'trend_user_activity',
    REVIEW_PERFORMANCE_VIEW: 'review_performance',
    AUDIT_REJECTIONS_VIEW: 'audit_reject_status'

};

export const EXCLUDED_FILTERS = {
    [VIEW_TYPE.ALERT.BAR] : [OVERVIEW_LOOKUP_NAMES.ALERT, OVERVIEW_LOOKUP_NAMES.DOMAIN,OVERVIEW_LOOKUP_NAMES.CREATED_ON],
    [VIEW_TYPE.ALERT.HEAT]: [OVERVIEW_LOOKUP_NAMES.STATUS, OVERVIEW_LOOKUP_NAMES.RISK_RATING,OVERVIEW_LOOKUP_NAMES.CREATED_ON],
    [OVERVIEW_VIEW_TYPE.TREND_USER_ACTIVITY_VIEW]: [ OVERVIEW_LOOKUP_NAMES.DOLLAR_VALUE, OVERVIEW_LOOKUP_NAMES.STATUS, OVERVIEW_LOOKUP_NAMES.CREATED_ON],
    [OVERVIEW_VIEW_TYPE.TREND_OVERDUE_ANOMALIES_VIEW]: [ OVERVIEW_LOOKUP_NAMES.DOLLAR_VALUE, OVERVIEW_LOOKUP_NAMES.STATUS, OVERVIEW_LOOKUP_NAMES.CREATED_ON],
    [OVERVIEW_VIEW_TYPE.TREND_ACTION_REQUIRED_VIEW]: [ OVERVIEW_LOOKUP_NAMES.DOLLAR_VALUE, OVERVIEW_LOOKUP_NAMES.STATUS, OVERVIEW_LOOKUP_NAMES.CREATED_ON],
    [OVERVIEW_VIEW_TYPE.TREND_IDENTIFIED_ANOMALIES_VIEW]:[ OVERVIEW_LOOKUP_NAMES.DOLLAR_VALUE, OVERVIEW_LOOKUP_NAMES.STATUS, OVERVIEW_LOOKUP_NAMES.CREATED_ON],
    [OVERVIEW_VIEW_TYPE.TREND_AUDIT_REJECTIONS_VIEW]: [ OVERVIEW_LOOKUP_NAMES.DOLLAR_VALUE, OVERVIEW_LOOKUP_NAMES.STATUS, OVERVIEW_LOOKUP_NAMES.CREATED_ON],
    [OVERVIEW_VIEW_TYPE.TREND_BUSINESS_REJECTIONS_VIEW]: [ OVERVIEW_LOOKUP_NAMES.DOLLAR_VALUE, OVERVIEW_LOOKUP_NAMES.STATUS, OVERVIEW_LOOKUP_NAMES.CREATED_ON],
}

export const RISK_DEFINITION = 'Risk defined based on Corruption Perceptions Index (CPI) scores (full list of rankings divided into thirds, and high, medium, and low risk categorizations assigned accordingly).'

export const ROWS_DROPDOWN_OPTIONS = ["30","50","100","200","500"]

export const HEAT_MAP_FIELDS = [
    {label: "Total Anomalies", name: 'total_anomaly_count'},
    {label: 'High Risk', name:'high_risk'},
    {label: "Medium Risk", name: 'medium_risk'},
    {label: "Low Risk", name: 'low_risk'},
    {label: "In Progress", name: 'in_progress'},
    {label: "Closed on Time", name: 'closed_on_time'},
    {label: "Closed Late", name: 'closed_late'},
    {label: "Action Assigned", name: 'action_assigned'},
    {label: "Audit Reject", name: 'audit_reject'},
    {label: "Business Reject", name: 'business_reject'},
]

// Grid Customization Constants

export const GRID_CUSTOMIZATION_CONSTANTS ={
    GRID_CUSTOMIZATION_PLACEHOLDER:'Choose Columns',
    SELECT_ALL : 'Select All',
    REVIEWER_REVIEWED_DATE_COL :'Reviewer Reviewed Date',
    REVIEWER_COL:'Reviewer',
    ORG_OWNER_REVIEWED_DATE_COL:'Org-Owner Reviewed Date',
    ORG_OWNER_COL: 'Org-Owner',
    AUDIT_STATUS_COL:'Audit Status',
    AUDITED_BY_COL :'Audited By',
    BUSINESS_STATUS_COL:'Business Status',
    LAST_UPDATED_COL:'Last Updated',
    COMPANY_CODE: 'Company Code',
    SOURCE_SYSTEM: 'Source System',
    PREVIOUS_ANOMALY_ID: 'Previous Anomaly ID'
}

export const UNASSIGNED_ANOMALIES = 'unassigned_anomalies';
export const COUNTRY_NAME = 'country_name';

export const CAMS_BOT_USERID = 'btp-cam';

export const TODO_POST_FILTERS = [
    {
      column: 'insight_display_status',
      type: 'in',
      value: [
        'reviewed-escalated',
        'reviewed-awaiting_org_owner_approval',
        'reviewed-awaiting_org_owner_closure',
      ],
    },
  ];

export const REFERENCE_POST_FILTERS = [
    {
      column: 'insight_display_status',
      type: 'in',
      value: ['unreviewed', 'reviewed-action_assigned', 'reviewed-action_complete', 'reviewed-no_action_required'],
    },
  ];

export const EXCLUDE_USERS_DEV = [
    // {
    //     userId: 'h479453',
    //     sub: 'f836f7eb-5595-d170-28cc-6c1841777c5a'
    // },
    {
        userId: 'h467659',
        sub: '3016976c-e2fa-74dc-385d-06507ff300d0'
    },
    // {
    //     userId: 'h518750',
    //     sub: '77143501-c5b4-cf38-8e62-7daf1fa02bf5'
    // },
    // {
    //     userId: 'h510812',
    //     sub: '5b41900b-343e-52c3-6e70-4481785b9c36'
    // },
    {
        userId: 'h498469',
        sub: '0e8fb38f-33c3-ad05-e72f-5b401c2c6685'
    },
    // {
    //     userId: 'h305829',
    //     sub: 'be0229ab-3837-2e8d-3d31-c5a4597754d4'
    // },
    // {
    //     userId: 'h532939',
    //     sub: '08e65b2d-2ba2-2c3a-0a9d-755796c1010c'
    // },
    {
        userId: 'h441643',
        sub: 'bfa08594-68bd-c5f4-bdb7-07803feb29d5'
    },
    {
        userId: 'h478393',
        sub: '657b8876-4b43-d389-8f17-c901237646b3'
    },
    {
        userId: 'h478886',
        sub: 'cb3fed93-364e-9eb2-8d3b-15b5da182130'
    },
    {
        userId: 'h518144',
        sub: '2a228e09-7488-f9ed-c2fa-5d4bc4ba9596'
    },
    {
        userId: 'h492305',
        sub: 'f0d1f6ab-1973-41f2-74ec-da0633ff0e91'
    },
    // {
    //     userId: 'h518147',
    //     sub: '64690f24-c219-345e-b246-7528cf340d08'
    // },
    {
        userId: 'h518143',
        sub: '690c597c-ef5a-aa70-a14e-38f21f3bf22e'
    },
    {
        userId: 'h518146',
        sub: '6479b2ec-68b8-5528-6b87-0ad94dda8cc7'
    },
    {
        userId: 'h536600',
        sub: '0129611c-dee4-902c-7417-c9580a43ffd8'
    },
    {
        userId: 'h473849',
        sub: '13b168e1-e0fe-fc33-6a16-a0d2d301a700'
    },
    {
        userId: 'h536601',
        sub: 'ed4c8b6a-c45c-5c77-e1ba-90a315725057'
    },
    {
        userId: 'h535395',
        sub: 'f63a3ffb-960d-9875-7363-b2418dcac53a'
    },
    {
        userId: 'h528352',
        sub: '17b0f388-9ff4-7143-badc-fe503b62c80e'
    },
    {
        userId: 'h486792',
        sub: '541b4268-8276-c93d-a721-85503100ce0d'
    },
    {
        userId: 'h514877',
        sub: '13bdf65b-8265-02c3-dccc-78d2ba959912'
    },
    {
        userId: 'h535396',
        sub: '83d8e3a7-b555-8c85-137d-b4fd4fba7a31'
    },
    {
        userId: 'h509831',
        sub: '37263c40-beb4-741d-fc01-6432a249c4a6'
    }
];

export const EXCLUDE_USERS_PROD = [
    {
        userId: 'h479453',
        sub: 'f836f7eb-5595-d170-28cc-6c1841777c5a'
    },
    {
        userId: 'h467659',
        sub: '3016976c-e2fa-74dc-385d-06507ff300d0'
    },
    {
        userId: 'h518750',
        sub: '77143501-c5b4-cf38-8e62-7daf1fa02bf5'
    },
    {
        userId: 'h510812',
        sub: '5b41900b-343e-52c3-6e70-4481785b9c36'
    },
    {
        userId: 'h498469',
        sub: '0e8fb38f-33c3-ad05-e72f-5b401c2c6685'
    },
    {
        userId: 'h305829',
        sub: 'be0229ab-3837-2e8d-3d31-c5a4597754d4'
    },
    {
        userId: 'h532939',
        sub: '08e65b2d-2ba2-2c3a-0a9d-755796c1010c'
    },
    {
        userId: 'h441643',
        sub: 'bfa08594-68bd-c5f4-bdb7-07803feb29d5'
    },
    {
        userId: 'h478393',
        sub: '657b8876-4b43-d389-8f17-c901237646b3'
    },
    {
        userId: 'h478886',
        sub: 'cb3fed93-364e-9eb2-8d3b-15b5da182130'
    },
    {
        userId: 'h518144',
        sub: '2a228e09-7488-f9ed-c2fa-5d4bc4ba9596'
    },
    {
        userId: 'h492305',
        sub: 'f0d1f6ab-1973-41f2-74ec-da0633ff0e91'
    },
    {
        userId: 'h518147',
        sub: '64690f24-c219-345e-b246-7528cf340d08'
    },
    {
        userId: 'h518143',
        sub: '690c597c-ef5a-aa70-a14e-38f21f3bf22e'
    },
    {
        userId: 'h518146',
        sub: '6479b2ec-68b8-5528-6b87-0ad94dda8cc7'
    },
    {
        userId: 'h536600',
        sub: '0129611c-dee4-902c-7417-c9580a43ffd8'
    },
    {
        userId: 'h473849',
        sub: '13b168e1-e0fe-fc33-6a16-a0d2d301a700'
    },
    {
        userId: 'h536601',
        sub: 'ed4c8b6a-c45c-5c77-e1ba-90a315725057'
    },
    {
        userId: 'h535395',
        sub: 'f63a3ffb-960d-9875-7363-b2418dcac53a'
    },
    {
        userId: 'h528352',
        sub: '17b0f388-9ff4-7143-badc-fe503b62c80e'
    },
    {
        userId: 'h486792',
        sub: '541b4268-8276-c93d-a721-85503100ce0d'
    },
    {
        userId: 'h514877',
        sub: '13bdf65b-8265-02c3-dccc-78d2ba959912'
    },
    {
        userId: 'h535396',
        sub: '83d8e3a7-b555-8c85-137d-b4fd4fba7a31'
    },
    {
        userId: 'h509831',
        sub: '37263c40-beb4-741d-fc01-6432a249c4a6'
    }
];


export const DATA_CONTEXT_QUESTIONS = ["Do you want to see more like this?"];


/** Path params for Opportunities API */
export const OPPORTUNITIES_API_PATHS_ADDCONEXT = {
    // opportunities: '/v1/opportunities',
    // openOpportunities: '/v1/opportunities/opportunity-open-list',
    // history: '/v1/opportunities/opportunity-history',
    // response: '/user-response', // accept & reject response
    // aopValues: '/v1/opportunities/aop-values',
    // statusPills:'/v1/opportunities/status',
    // categoryStatusPills: '/v1/opportunities/category',
    // export:'/v1/opportunities/export',
    // autoCompelte:'/v1/opportunities/auto-complete',
    // autoCompelteHistory: 'v1/opportunities/auto-complete-history',
    dataContextPost: '/v1/acp/datacontext-game',
    dataContextGet: '/v1/acp/data-context-feedback',
    dataContextPartNumber: 'v1/acp/part-number'
};
